import { MapConfig, ColorConfigs } from "./types";

export const middleOfUSA = { lat: 37.8, lng: -96 };
export const initialZoom = 4;
export const maxZoom = 6.5;

interface Texts {
  label: string;
  infoBox: string;
  getValue: ({ value }: { value: number }) => string | null;
}

export const MapTextConfig: { [key in MapConfig]?: Texts } = {
  airQuality: {
    label: "Air Pollutants",
    infoBox: "Air pollutants percentual",
    getValue: ({ value }) => value.toString(),
  },
  pollen: {
    label: "Pollen Heatmaps",
    infoBox: "Pollen percentual",
    getValue: ({ value }) => value.toString(),
  },
  liveWeather: {
    label: "Weather",
    infoBox: "Current weather",
    getValue: ({ value }) => (value !== null ? `${value}ºF` : null),
  },
  water: {
    label: "Water Pollutant",
    infoBox: "Water Pollutant percentual",
    getValue: ({ value }) =>
      value !== null ? `${value} pollutants per mm` : null,
  },
};
export const disabledRegionColor = "#F2F1EA";
export const colorConfigs: ColorConfigs = {
  airQuality: [
    {
      min: 0,
      minTxt: "0",
      max: 20,
      color: "#fff2cc",
      level: "Low",
    },
    {
      min: 20.01,
      minTxt: "20",
      max: 40,
      color: "#ffe499",
      level: "Low - Medium",
    },
    {
      min: 40.01,
      minTxt: "40",
      max: 60,
      color: "#fcce59",
      level: "Medium",
    },
    {
      min: 60.01,
      minTxt: "60",
      max: 80,
      color: "#ffbc00",
      level: "Medium - High",
    },
    {
      min: 80.01,
      minTxt: "80",
      max: 100,
      color: "#bf8d00",
      level: "High",
    },
  ],
  pollen: [
    {
      min: 0,
      max: 2.4,
      color: "#ffdcc0",
      level: "Low",
    },
    {
      min: 2.5,
      max: 4.8,
      color: "#ffb266",
      level: "Low - Medium",
    },
    {
      min: 4.9,
      max: 7.2,
      color: "#ff7f00",
      level: "Medium",
    },
    {
      min: 7.3,
      max: 9.6,
      color: "#d36705",
      level: "Medium - High",
    },
    {
      min: 9.7,
      max: 12,
      color: "#a35616",
      level: "High",
    },
  ],
  liveWeather: [
    {
      min: 0,
      minTxt: "0",
      max: 20,
      color: "#f8d1cc",
    },
    {
      min: 20.01,
      minTxt: "20",
      max: 40,
      color: "#f1a499",
    },
    {
      min: 40.01,
      minTxt: "40",
      max: 60,
      color: "#e5675a",
    },
    {
      min: 60.01,
      minTxt: "60",
      max: 80,
      color: "#dd1b00",
    },
    {
      min: 80.01,
      minTxt: "80",
      max: 100,
      color: "#931002",
    },
  ],
  water: [
    {
      min: 0,
      minTxt: "0",
      max: 4,
      color: "#fffad2",
    },
    {
      min: 4.01,
      minTxt: "4",
      max: 8,
      color: "#fff27d",
    },
    {
      min: 8.01,
      minTxt: "8",
      max: 12,
      color: "#ffbc00",
    },
    {
      min: 12.01,
      minTxt: "12",
      max: 15,
      color: "#ff7f00",
    },
    {
      min: 15.01,
      minTxt: "15",
      max: 25,
      color: "#dd1b00",
    },
  ],
};
